import { get, upload, put, del } from '@api/request';

export async function fetchBuildingPermitConfigurations(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/configurations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertBuildingPermitConfiguration(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/configurations`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function fetchBuildingPermitConfiguration(
  { appraisalService },
  authenticationToken,
  { configID },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/config/${configID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateBuildingPermitConfiguration(
  { appraisalService },
  authenticationToken,
  { configID, payload },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/config/${configID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export const downloadBuildingPermitImportFile = async (
  { appraisalService },
  authenticationToken,
  { importID, s3ID },
) => {
  const url = `${appraisalService}/appraisal/buildingpermitimport/${importID}/file`;
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export async function fetchBuildingPermitFields(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/buildingpermitimportconfig/fields`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function downloadBuildingPermitConfigFile(
  { appraisalService },
  authenticationToken,
  { configID },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/config/${configID}/file`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteBuildingPermitConfiguration(
  { appraisalService },
  authenticationToken,
  { configID },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/config/${configID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchBuildingPermitImports(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/buildingpermitimports`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createBuildingPermitImport(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimports`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function fetchBuildingPermitImport(
  { appraisalService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/${importID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function undoBuildingPermitImport(
  { appraisalService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/${importID}/undo`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function analyzeBuildingPermitImport(
  { appraisalService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/${importID}/analyze`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function importBuildingPermitImport(
  { appraisalService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/${importID}/import`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function matchBuildingPermitImport(
  { appraisalService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/${importID}/match`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function fetchBuildingPermitImportMatched(
  { appraisalService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/${importID}/matched`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchBuildingPermitImportUnmatched(
  { appraisalService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalService}/appraisal/buildingpermitimport/${importID}/unmatched`;
  const { body } = await get(authenticationToken, url);
  return body;
}
